var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-60.000000, -1038.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Search",
    transform: "translate(60.000000, 1038.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1246907,4.26325641e-14 C25.6828303,4.26325641e-14 31,5.43894724 31,12.1472858 C31,18.8556244 25.6828303,24.2945717 19.1246907,24.2945717 C16.8476002,24.2945717 14.7288471,23.6274832 12.9218209,22.4906997 L12.9218209,22.4906997 L3.521524,32 C1.49282533,29.9248387 1.49282533,26.5590282 3.521524,24.4838669 L3.521524,24.4838669 L9.15141019,18.7260534 C7.95299357,16.8290523 7.24938149,14.5737062 7.24938149,12.1472858 C7.24938149,5.43894724 12.5665512,4.26325641e-14 19.1246907,4.26325641e-14 Z M19.1246907,4.04909528 C14.759525,4.04909528 11.2078179,7.68214602 11.2078179,12.1472858 C11.2078179,16.6124257 14.759525,20.2454764 19.1246907,20.2454764 C23.4898565,20.2454764 27.0415636,16.6124257 27.0415636,12.1472858 C27.0415636,7.68214602 23.4898565,4.04909528 19.1246907,4.04909528 Z M19.1246907,9.11046438 C20.764473,9.11046438 22.0935181,10.4699481 22.0935181,12.1472858 C22.0935181,13.8246236 20.764473,15.1841073 19.1246907,15.1841073 C17.4849085,15.1841073 16.1558634,13.8246236 16.1558634,12.1472858 C16.1558634,10.4699481 17.4849085,9.11046438 19.1246907,9.11046438 Z",
    id: 261,
    transform: "translate(16.500000, 16.000000) scale(-1, 1) translate(-16.500000, -16.000000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionSearch);
export default __webpack_public_path__ + "static/media/navigation-and-action-search.9b33e46b.svg";
export { ForwardRef as ReactComponent };